import { Controller } from "@hotwired/stimulus"

export class Base extends Controller {
}
